import sectionProductReviews04Css from '../css-snippets/section-product-reviews-04';

const html = `
<style>${sectionProductReviews04Css}</style>
<div
  class="product-reviews-wrapper product-reviews-wrapper-unique-id"
  data-id="unique-id"
  data-attribute="product-reviews-container"
  data-top-padding="true"
  data-bottom-padding="true"
  style="background-color: #F7F7F7"
>
  <div class="container">
    <div
      class="review-overview"
      data-attribute="review-overview"
    >
      <div class="review-header" data-attribute="review-title">
        <h2 style="text-align:center;"><strong>Real, Verified Results:</strong><br><strong>See Why Families Are </strong><span style="color:rgb(221,29,29);"><strong>Replacing Their Detectors</strong></span><strong> and&nbsp;Calling</strong><br><strong>&nbsp;Haven "Life Saving"</strong></h2>
        <p style="text-align:center;">Note: All reviews below are from actual paying customers.&nbsp;<br>They have been authenticated and verified</p>
      </div>
    </div>

    <div class="reviews-list">
      <div class="reviews-container"></div>
    </div>
  </div>
</div>

<div onclick="window.closeImageModal()" class="modal-preview-image" style="display: none;">
  <div onclick="event.stopPropagation();" class="modal-preview-image-content">
    <img loading="lazy" data-attribute="modal-preview-image" src="" alt="">
    <button type="button" class="close-modal-preview-image" data-attribute="close-modal-preview-image" onclick="window.closeImageModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>
 </div>
`;
export default html;
